module.exports = __webpack_public_path__ + "zvetseni-prsou_59_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_59_after.jpg
// module id = 1353
// module chunks = 0